export enum DummyPermission {
	VIEW = 'view',
	EDIT = 'edit',
	DELETE = 'delete',
	CREATE = 'create',
}

export const useIsGranted = () => {
	return (permission: DummyPermission | DummyPermission[]): boolean => {
		return true; // always grants permission
	};
};
